import React from "react";
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid'
import { classNames, getInitials } from "../../helpers";

export default function TwSectionHeadings(props) {
  const { headTitle = "", breadcrumbs = [], headActions = [] } = props
  /* breadcrumbs: [{ title: string, onClick: any = () => { } }] = [] */

  return (
    <div className="p-5">
      {breadcrumbs.length > 0 && (<div>
        <nav aria-label="Back" className="sm:hidden">
          <button type="button" onClick={breadcrumbs.length >= 2 && breadcrumbs[breadcrumbs.length - 2]?.onClick ? breadcrumbs[breadcrumbs.length - 2].onClick : () => { }} className="flex items-center text-sm font-medium text-gray-500 hover:text-gray-700">
            <ChevronLeftIcon aria-hidden="true" className="mr-1 -ml-1 size-5 shrink-0 text-gray-400" />
            Back
          </button>
        </nav>
        <nav aria-label="Breadcrumb" className="hidden sm:flex">
          <ol className="flex items-center space-x-4">
            {breadcrumbs.map((data, index) => {
              return (
                <li key={index}>
                  <div className="flex items-center">
                    {(index > 0) && (<ChevronRightIcon aria-hidden="true" className="size-5 shrink-0 text-gray-400" />)}
                    <button type="button" onClick={index < (breadcrumbs.length - 1) && data?.onClick ? data.onClick : () => { }} className={classNames((index > 0) ? "ml-4" : "", "text-sm font-medium text-gray-500 hover:text-gray-700")}>
                      {data?.title || ""}
                    </button>
                  </div>
                </li>
              )
            })}
          </ol>
        </nav>
      </div>)}
      <div className="mt-2 md:flex md:items-center md:justify-between">
        <div className="min-w-0 flex-1">
          <h2 className="text-2xl/7 font-bold text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">
            {headTitle}
          </h2>
        </div>
        <ul className="mt-4 flex gap-3 shrink-0 md:mt-0 md:ml-4">
        {/* <ul className="mt-4 flex flex-col-reverse justify-stretch space-y-4 space-y-reverse sm:flex-row-reverse sm:justify-end sm:space-y-0 sm:space-x-3 sm:space-x-reverse md:mt-0 md:flex-row md:space-x-3"> */}
          {headActions.map((data, index) => {
            return (<li
              key={index}
              className="inline-flex items-center justify-start rounded-md w-full sm:w-auto"
            >{data}</li>)
            // return data
          })}
        </ul>
      </div>
    </div >
  );
}
